<div #divSpinner class="cargando" [style.display]="cargando ? '' : 'none'">
    <mat-spinner style="margin:0 auto; margin-top: 15%;"></mat-spinner>
</div>
<div class="customers">
    <div class="card">
        <div class="card-body" style="padding: 20px;">
            <div class="row">
                <div class="col-sm-6">
                    <p class="titulo-card-naranja">Objetivos</p>
                </div>
                <div class="col-sm-6" style="text-align: right;">
                    <button type="button" class="btn btn-light btn-volver" style="background: #FF8685 0% 0% no-repeat padding-box;color: #FFEEEE;" (click)="guardarObjetivos()" *ngIf="guardarEditar && !simulacion"> Guardar</button>
                    <button type="button" class="btn btn-light btn-volver" *ngIf="simulacion" (click)="volver2()"> Volver</button>
                    <button type="button" class="btn btn-light btn-volver" *ngIf="!simulacion" (click)="volver()"> Volver</button>
                </div>
            </div>

            <div class="row">
                <div class="col-sm-6" style="border-right: 1px solid #E8E8E8;">
                    <div class="row">
                        <div class="col-sm-6">


                        </div>
                        <div class="col-sm-6" style="text-align: right;">
                            <p style="margin-right: 10px;
                            font: normal normal bold 16px/20px Montserrat;
                            letter-spacing: 0px;
                            color: #3A445E;
                            text-transform: uppercase;
                            
                            opacity: 1;">Contexto Institucional</p>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-sm-12">
                            <p style="text-align: left;font: normal normal bold 12px/19px Montserrat;letter-spacing: 0px; margin-left: 15px; color: #FF8685;text-transform: uppercase;opacity: 1;">Objetivos</p>
                        </div>
                    </div>
                    <div class="row" style="padding: 15px;">
                        <div class="col-sm-12" style="background: #F6F6F6 0% 0% no-repeat padding-box;border-radius: 10px;opacity: 1;padding: 15px;text-align: justify;">
                            <p><b>Calidad Educativa y bienestar Integral: </b> Entregar Educación Parvularia de calidad, pertinente a las realidades de los territorios y que garantice el logro de aprendizajes y el desarrollo integral de los niños y niñas a través de una oferta flexible y confiable para las familias y la comunidad. Para ello, se favorecen procesos eficientes desde un enfoque sostenible, innovador e inclusivo, ajustados a estándares de calidad pertinentes a las características de cada programa y modalidad.</p>
                            <br>
                            <p><b>Personas y cultura: </b>Contar con personas, equipos y liderazgos idóneos para los cargos de los diferentes niveles de la organización (directivos, educadores y educadoras de párvulos, técnicos, entre otros y otras), en una institución que promueve la calidad de vida y salud mental y en donde la cultura es impulsada tanto en oficinas administrativas como en unidades educativas, siendo un fiel reflejo de los valores institucionales. </p>
                            <br>
                            <p><b>Alianza Estratégica: </b>Impulsar la generación de redes o alianzas estratégicas con diferentes actores del Sistema de Educación Parvularia y/u otros sectores, con el fin de identificar potenciales sinergias y trabajar colaborativamente para la consecución de objetivos comunes.  </p>
                            <br>
                            <p><b>Modernización Institucional:</b> Fortalecer la gestión institucional apuntando a procesos eficientes y respuestas oportunas tanto internamente como de cara a la ciudadanía, instalando una orgánica institucional que fortalezca nuestra coordinación y acompañe los desafíos institucionales actuales y futuros, además de promover la toma de decisiones en base a datos disponibles en tiempo y forma. </p>
                        </div>
                    </div>


                </div>
                <div class="col-sm-6">
                    <div class="row">
                        <div class="col-sm-6">
                            <p style="text-align: left;
                            font: normal normal bold 16px/20px Montserrat;
                            letter-spacing: 0px;
                            color: #3A445E;
                            text-transform: uppercase;
                            margin-left: 10px;
                            opacity: 1;">Contexto Unidad Educativa</p>
                        </div>
                        <div class="col-sm-6" style="text-align: right;">

                        </div>
                    </div>

                    <div class="row">
                        <div class="col-sm-12">
                            <p style="text-align: left;font: normal normal bold 12px/19px Montserrat;letter-spacing: 0px; margin-left: 15px; color: #FF8685;text-transform: uppercase;opacity: 1;">Objetivos Generales</p>
                        </div>
                    </div>
                    <div class="row" style="padding: 15px;">
                        <div class="col-sm-12">
                            <mat-form-field class="w-100" hintLabel="Max. 5000 caracteres">
                                <textarea
                                rows="8" 
                                cols="20" 
                                class="text-area-ideario" 
                                style="height: 570px;"
                                maxlength="5000"
                                autocomplete="off"
                                matInput
                                [disabled]="!guardarEditar"
                                id="objetivosGenerales"
                                name="objetivosGenerales"
                                (change)="change()"
                                [(ngModel)]="this.proyectoEducativoObjetivosData.objetivosGenerales"
                                ></textarea>
                                <mat-hint align="end">{{this.proyectoEducativoObjetivosData.objetivosGenerales.length || 0}}/5000</mat-hint>
                            </mat-form-field>  
                            <mat-error *ngIf="this.proyectoEducativoObjetivosData.objetivosGenerales.length>4999">Max. caracteres alcanzado</mat-error>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-sm-12">
                            <p style="text-align: left;font: normal normal bold 12px/19px Montserrat;letter-spacing: 0px; margin-left: 15px;color: #FF8685;text-transform: uppercase;opacity: 1;">Objetivos Estratégicos de la unidad educativa</p>
                        </div>
                    </div>
                    <div class="row" style="padding: 15px;">
                        <div class="col-sm-12">
                            <mat-form-field class="w-100" hintLabel="Max. 5000 caracteres">
                                <textarea
                                rows="8" 
                                cols="20" 
                                class="text-area-ideario" 
                                style="height: 570px;"
                                maxlength="5000"
                                autocomplete="off"
                                matInput
                                [disabled]="!guardarEditar"
                                id="objetivosEstrategicos"
                                name="objetivosEstrategicos"
                                (change)="change()"
                                [(ngModel)]="this.proyectoEducativoObjetivosData.objetivosEstrategicos"
                                ></textarea>
                                <mat-hint align="end">{{this.proyectoEducativoObjetivosData.objetivosEstrategicos.length || 0}}/5000</mat-hint>
                            </mat-form-field>  
                            <mat-error *ngIf="this.proyectoEducativoObjetivosData.objetivosEstrategicos.length>4999">Max. caracteres alcanzado</mat-error>
                        </div>
                    </div>

                </div>
            </div>
        </div>
    </div>
</div>